<template>
    <div>
        <h1>Benutzer {{user.firstname}} {{user.lastname}}</h1>
        <p>Email: {{user.email}}</p>
        <p>Email verifiziert: {{user.emailVerified ? "Ja" : "Nein"}}</p>
        <p>Benutzer aktiviert: {{user.enabled ? "Ja" : "Nein"}}</p>
        <p>Visierer: <span v-if="user.visor != null"><router-link :to="'/users/'+user.visorId">
                            {{user.visor.firstname}}
                            {{user.visor.lastname}}
                        </router-link></span><span v-if="user.visor == null">Kein Visierer</span></p>
      <v-data-table :items="services"
                    item-key="id"
                    :headers="headers">
        <template v-slot:item.description="{ item }">
          {{getShortText(item.description)}}
        </template>
        <template v-slot:item.startDate="{ item }">
          {{getDate(item.startDate)}}
        </template>
        <template v-slot:item.endDate="{ item }">
          {{getDate(item.endDate)}}
        </template>
        <template v-slot:item.serviceType="{ item }">
          {{item.serviceType.name}}
        </template>
        <template v-slot:item.confirmed="{ item }">
          <v-simple-checkbox v-model="item.confirmed" disabled></v-simple-checkbox>
        </template>
      </v-data-table>
    </div>
</template>

<script>
    import {accountService} from "../services/accountService";

    export default {
        name: "User",
        data() {
            return {
                user: {},
              services: [],
              headers: [
                {
                  text: "Beschreibung",
                  value: "description"
                },
                {
                  text: "Startdatum",
                  value: "startDate"
                },
                {
                  text: "Enddatum",
                  value: "endDate"
                },
                {
                  text: "Leistungstyp",
                  value: "serviceType"
                },
                {
                  text: "Visiert",
                  value: "confirmed"
                },
              ],
            }
        },
      methods: {
        getShortText(text) {
          if (text.length > 15) {
            var trimmedString = text.substr(0, 15);

            return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "..."
          }
          return text
        },
        showDetail(service) {
          this.$router.push("/services/"+service.id);
        },
        getDate(date) {
          return new Date(date).toLocaleDateString('de-CH');
        },
      },
        mounted() {
            let self = this;
            accountService.getQuery("id="+this.$route.params.id).then((response) => {
                self.user = response[0];
                self.services = response[0].services;
                document.title = "Benutzer " + self.user.firstname + " " + self.user.lastname;
            }).catch((error) => {
                console.log(error)
            });}
    }
</script>

<style scoped>

</style>